<template>
  <div class="user">
    <!-- <div class="photo">
      <img src="static/img/faces/face-2.jpg" alt="user avatar"/>
    </div> -->
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span v-if="user"> {{ user[0].name.toUpperCase() }}<b class="caret"></b></span>
      </a>
      <!-- <a @click="logout()">
        <span class="sidebar-normal">Logout</span>
      </a> -->
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Mp</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Ep</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li>
            <li>
              <a @click="logout()">
                <span class="sidebar-mini-icon">L</span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true,
        user:''
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      logout(){
        this.$store
        .dispatch("user/logout")
        .then(() => {
          localStorage.clear();
          this.$router.push({ path: "/login" });
        }).catch(error => {
          console.log("Login Errors :", error);
        });
      },
    },

    mounted() {
       this.user = JSON.parse(localStorage.getItem("user"));
    },
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
  .user .info > a > span{
    font-size: 1rem;
  }
</style>
